import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { BackgroundTask, BackgroundTaskStatus, BackgroundTaskType } from '../../models/background-task';
import { BackgroundTaskService } from '../../services/background-task.service';

@Component({
    selector: 'background-task-list',
    templateUrl: './background-task-list.component.html',
    styleUrls: ['./background-task-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BackgroundTaskListComponent {
  @Input() tasks: BackgroundTask[];
  @Output() refreshTasks = new EventEmitter<void>();

  displayedColumns: string[] = ['taskType', 'id', 'status', 'action'];

  constructor(private backgroundTaskService: BackgroundTaskService) { }

  loadTaskList(): void {
    this.refreshTasks.emit();
  }

  getTaskTypeLabel(task: BackgroundTask): string {
    switch (task.type) {
      case BackgroundTaskType.ResyncPim:
        return 'Resync PIM';
      case BackgroundTaskType.ResyncIdentity:
        return 'Resync Identity';
      default: return ''
    }
  }

  cancel(task: BackgroundTask) {
    this.backgroundTaskService.cancelTask(task.id).subscribe(() => this.taskCancelled(task.id));
  }

  isCancellable(task: BackgroundTask) {
    return task.status == BackgroundTaskStatus.Running || task.status == BackgroundTaskStatus.Created;
  }

  taskCancelled(taskId: string) {
    var task = this.tasks.find(t => t.id == taskId);
    task.status = BackgroundTaskStatus.Cancelled;
  }
}
